// ** React Imports
import { lazy } from 'react';

const FoodRoutes = [
  {
    path: 'catalog/products',
    component: lazy(() => import('views/products')),
  },
  {
    path: 'product/add',
    component: lazy(() => import('views/products/product-form-page')),
  },
  {
    path: 'product/:uuid',
    component: lazy(() => import('views/products/product-form-page')),
  },
  {
    path: 'product/view/:uuid',
    component: lazy(() => import('views/products/product-detail-page')),
  },
  {
    path: 'product-clone/:uuid',
    component: lazy(() => import('views/products/product-clone')),
  },
  {
    path: 'catalog/product/import',
    component: lazy(() => import('views/products/product-import')),
  },
  {
    path: 'catalog/purchase-counters',
    component: lazy(() => import('views/product-counters')),
  },
];

export default FoodRoutes;
